export default [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/auth/login.vue')
  },
  {
    path: '/author',
    name: 'author',
    component: () => import('@/views/auth/author.vue')
  },
  {
    path: '/bind/mobile',
    name: 'bindmobile',
    component: () => import('@/views/auth/bindmobile.vue')
  }
]
